export class Notification {
  toEmailAddress: string | string[];
  subject: string;
  message: string;
  ccEmailAddress?: string | string[];
}
